<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <b-row class="pt-sm-1">
            <b-col sm="1">
              <span class="card-title wise-card-title">관리자 공지</span>
            </b-col>
            <b-col sm="11">
              <div style="float:right;">
                <b-button type="button" variant="primary" v-bind:href="'#/user/manage'">더보기</b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <b-row class="pt-sm-1">
            <b-col sm="1">
              <span class="card-title wise-card-title">기간 설정</span>
            </b-col>
            <b-col sm="2">
              <date-picker v-model="fullDate"
                          type="date"
                          range
                          placeholder="조회기간 선택"
                          :lang="datepickerLang"
                          style="width: 100%;"
              />
            </b-col>
            <b-col sm="1">
              <b-button type="button" variant="primary" style="width: 100%;" v-on:click="searchDashboard()">검색</b-button>
            </b-col>
            <b-col sm="8">
              <div style="float:right;">
                <button type="button" v-if="!isDownload" class="btn btn-outline-success" v-on:click="downloadExcel()">
                  기간 통계 다운로드
                </button>
                <button type="button" v-else role="status" class="btn btn-outline-success" v-on:click="downloadExcel()">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  기간 통계 다운로드
                </button>

                <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('all')">전체</button>
                <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_week')">이번주</button>
                <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_month')">이번달</button>
                <!-- <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('prev_month')">지난달</button> -->
                <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('this_year')">올해</button>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- ################################## 회원현황 ################################## -->
        <b-card>
          <b-row class="pt-sm-1 mb-1">
            <b-col sm="1">
              <span class="card-title wise-card-title">회원현황</span>
            </b-col>
            <b-col sm="11">
              <div style="float:right;">
                <b-button type="button" variant="primary" v-bind:href="'#/user/manage'">더보기</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="table-responsive-sm">
                <table class="table table-bordered">
                  <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td style="background-color:#f1f1f1"><label class="col-form-label">일반회원</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">구독회원</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">휴면회원</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">총회원수</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">활성회원</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">신규회원</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">만료대기 회원</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">{{userStatistics.user_active_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{userStatistics.user_company_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{userStatistics.user_noActive_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{userStatistics.totalCount | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardUserData.user_login_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardUserData.user_join_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardUserData.user_30day_Count | numberComma}}</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- ################################## 기업회원 현황 ################################## -->
        <b-card>
          <b-row class="pt-sm-1 mb-1">
            <b-col sm="2">
              <span class="card-title wise-card-title">구독회원 현황</span>
            </b-col>
            <b-col sm="10">
              <div style="float:right;">
                <b-button type="button" variant="primary" v-bind:href="'#/user/companyusermanage'">더보기</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="table-responsive-sm">
                <table class="table table-bordered">
                  <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td style="background-color:#f1f1f1"><label class="col-form-label">고객</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">영업지원</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">내부</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">기타</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">총합</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">{{dashboardCompanyData.company_cust_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardCompanyData.company_support_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardCompanyData.company_in_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardCompanyData.company_etc_Count | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardCompanyData.totalCount | numberComma}}</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- ################################## 주문현황 ################################## -->
        <b-card>
          <b-row class="pt-sm-1 mb-1">
            <b-col sm="1">
              <span class="card-title wise-card-title">주문현황</span>
            </b-col>
            <b-col sm="11">
              <div style="float:right;">
                <b-button type="button" variant="primary" v-bind:href="'#/order/product'">더보기</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="table-responsive-sm">
                <table class="table table-bordered">
                  <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td style="background-color:#f1f1f1"><label class="col-form-label">구분</label></td>
                      <td colspan="2" style="background-color:#f1f1f1"><label class="col-form-label">총주문(금액/건수)</label></td>
                      <td colspan="2" style="background-color:#f1f1f1"><label class="col-form-label">입금대기(금액/건수)</label></td>
                      <td colspan="2" style="background-color:#f1f1f1"><label class="col-form-label">결제완료(금액/건수)</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">구독회원 가입</label></td>
                      <td><label class="col-form-label">{{dashboardOrderCompany.totalOrderPrice | numberComma}} 원</label></td>
                      <td><label class="col-form-label">{{dashboardOrderCompany.totalOrderCnt | numberComma}} 건</label></td>
                      <td><label class="col-form-label">{{dashboardOrderCompany.depositPrice | numberComma}} 원</label></td>
                      <td><label class="col-form-label">{{dashboardOrderCompany.depositCnt | numberComma}} 건</label></td>
                      <td><label class="col-form-label">{{dashboardOrderCompany.paymentPrice | numberComma}} 원</label></td>
                      <td><label class="col-form-label">{{dashboardOrderCompany.paymentCnt | numberComma}} 건</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">보고서 판매</label></td>
                      <td><label class="col-form-label">{{dashboardOrderReport.totalOrderPrice | numberComma}} 원</label></td>
                      <td><label class="col-form-label">{{dashboardOrderReport.totalOrderCnt | numberComma}} 건</label></td>
                      <td><label class="col-form-label">{{dashboardOrderReport.depositPrice | numberComma}} 원</label></td>
                      <td><label class="col-form-label">{{dashboardOrderReport.depositCnt | numberComma}} 건</label></td>
                      <td><label class="col-form-label">{{dashboardOrderReport.paymentPrice | numberComma}} 원</label></td>
                      <td><label class="col-form-label">{{dashboardOrderReport.paymentCnt | numberComma}} 건</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- ################################## 콘텐츠 현황 ################################## -->
        <b-card>
          <b-row class="pt-sm-1 mb-1">
            <b-col sm="1">
              <span class="card-title wise-card-title">콘텐츠 현황</span>
            </b-col>
            <b-col sm="11">
              <div style="float:right;">
                <b-button type="button" variant="primary" v-bind:href="'#/contents/list'">더보기</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="table-responsive-sm">
                <table class="table table-bordered">
                  <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td style="background-color:#f1f1f1"><label class="col-form-label">구분</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">광고/마케팅</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">마켓</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">소비자</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">DMC브리프</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">합계</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">유료</label></td>
                      <td><label class="col-form-label">{{dashboardContentsPay.adCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsPay.marketCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsPay.custCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsPay.briefCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsPay.totalCnt | numberComma}}</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">무료</label></td>
                      <td><label class="col-form-label">{{dashboardContentsFree.adCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsFree.marketCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsFree.custCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsFree.briefCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsFree.totalCnt | numberComma}}</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">합계</label></td>
                      <td><label class="col-form-label">{{dashboardContentsTotal.adCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsTotal.marketCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsTotal.custCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsTotal.briefCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardContentsTotal.totalCnt | numberComma}}</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <!-- ################################## 고객문의 현황 ################################## -->
        <b-card>
          <b-row class="pt-sm-1 mb-1">
            <b-col sm="2">
              <span class="card-title wise-card-title">고객문의 현황</span>
            </b-col>
            <b-col sm="10">
              <div style="float:right;">
                <b-button type="button" variant="primary" v-bind:href="'#/customer/qamanager'">더보기</b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="table-responsive-sm">
                <table class="table table-bordered">
                  <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td style="background-color:#f1f1f1"><label class="col-form-label">답변대기</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">답변완료</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">보고서 의뢰(대기)</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">보고서 의뢰(완료)</label></td>
                      <td style="background-color:#f1f1f1"><label class="col-form-label">합계</label></td>
                    </tr>
                    <tr class="" style="border-bottom:1px solid #a3b6c0; text-align:center">
                      <td><label class="col-form-label">{{dashboardQAData.qaWaitCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardQAData.qaSuccCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardQAData.reqWaitCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardQAData.reqWaitCnt | numberComma}}</label></td>
                      <td><label class="col-form-label">{{dashboardQAData.totalCnt | numberComma}}</label></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const moment = require("moment");

export default {
  name: 'dashboard',
  data() {
    return {
      datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
      fullDate: [],
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      userStatistics: {
        totalCount: 0,
        user_active_Count: 0,
        user_company_Count: 0,
        user_noActive_Count: 0,
      },
      dashboardUserData: {
        user_login_Count: 0,
        user_join_Count: 0,
        user_30day_Count: 0,
      },
      dashboardCompanyData: {
        totalCount: 0,
        company_cust_Count: 0,
        company_support_Count: 0,
        company_in_Count: 0,
        company_etc_Count: 0,
      },
      dashboardOrderCompany: {
        totalOrderCnt: 0,
        totalOrderPrice: 0,
        depositCnt: 0,
        depositPrice: 0,
        paymentCnt: 0,
        paymentPrice: 0,
      },
      dashboardOrderReport: {
        totalOrderCnt: 0,
        totalOrderPrice: 0,
        depositCnt: 0,
        depositPrice: 0,
        paymentCnt: 0,
        paymentPrice: 0,
      },
      dashboardContentsPay: {
        totalCnt: 0,
        adCnt: 0,
        marketCnt: 0,
        custCnt: 0,
        briefCnt: 0,
      },
      dashboardContentsFree: {
        totalCnt: 0,
        adCnt: 0,
        marketCnt: 0,
        custCnt: 0,
        briefCnt: 0,
      },
      dashboardContentsTotal: {
        totalCnt: 0,
        adCnt: 0,
        marketCnt: 0,
        custCnt: 0,
        briefCnt: 0,
      },
      dashboardQAData: {
        totalCnt: 0,
        qaWaitCnt: 0,
        qaSuccCnt: 0,
        reqWaitCnt: 0,
        reqSuccCnt: 0,
      },
      queryParams: {
        name: '',
        ageRange: [],
        letter_yn: [],
        gender: [],
        grade: [],
        pannel: [],
        industry_key: [],
        authority: [],
        user_status: [],
        employee : [],
        menu_code: [], //대메뉴
        sales_type: 'all',
        type_code: 'all',
        qaSearchType: 'all',
        qastatus:'0',
      },
      isDownload: false,
    }
  },
  components: {
    DatePicker,
  },
  mounted: function() {
    this.$store.dispatch('ORDERTOTALCNT', this); //주문관리 new 확인
    //this.$store.dispatch('QNATOTALCNT', this); //고객문의관리 신규 문의 노출 확인
    this.dateRange('this_week');
    this.searchDashboard();
  },
  methods: {
    searchDashboard(){
      this.userStatistics = {
        totalCount: 0,
        user_active_Count: 0,
        user_company_Count: 0,
        user_noActive_Count: 0,
      };
      this.dashboardUserData = {
        user_login_Count: 0,
        user_join_Count: 0,
        user_30day_Count: 0,
      };
      this.dashboardCompanyData = {
        totalCount: 0,
        company_cust_Count: 0,
        company_support_Count: 0,
        company_in_Count: 0,
        company_etc_Count: 0,
      };
      this.dashboardOrderCompany = {
        totalOrderCnt: 0,
        totalOrderPrice: 0,
        depositCnt: 0,
        depositPrice: 0,
        paymentCnt: 0,
        paymentPrice: 0,
      };
      this.dashboardOrderReport = {
        totalOrderCnt: 0,
        totalOrderPrice: 0,
        depositCnt: 0,
        depositPrice: 0,
        paymentCnt: 0,
        paymentPrice: 0,
      };
      this.dashboardContentsPay = {
        totalCnt: 0,
        adCnt: 0,
        marketCnt: 0,
        custCnt: 0,
        briefCnt: 0,
      };
      this.dashboardContentsFree = {
        totalCnt: 0,
        adCnt: 0,
        marketCnt: 0,
        custCnt: 0,
        briefCnt: 0,
      };
      this.dashboardContentsTotal = {
        totalCnt: 0,
        adCnt: 0,
        marketCnt: 0,
        custCnt: 0,
        briefCnt: 0,
      };
      this.dashboardQAData = {
        totalCnt: 0,
        qaWaitCnt: 0,
        qaSuccCnt: 0,
        reqWaitCnt: 0,
        reqSuccCnt: 0,
      };

      this.getUserStatistics();
      this.getDashboardUserData();
      this.getDashboardCompanyData();
      this.getDashboardOrderCompany();
      this.getDashboardOrderReport();
      this.getDashboardReportData();
      this.getDashboardQAData();
      this.getDashboardReportRequest();
    },
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
    // 회원현황 - 일반회원,기업회원,휴면회원,총회원
    getUserStatistics() {
      this.statusLoding = true;
      var token = sessionStorage.getItem("myToken");

      // this.queryParams.startDate = this.getFormatDate(this.fullDate[0]);
      // this.queryParams.endDate = this.getFormatDate(this.fullDate[1]);
      this.queryParams.startDate = '';
      this.queryParams.endDate = '';

      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append("objs", param);

      this.$http
        .post("/api/select/reportStatistics?access_token=" + token, data, null)
        .then((result) => {
          this.userStatistics = result.data;
          this.statusLoding = false;
        });
    },
    // 회원현황 - 활성회원,신규회원,만료대기
    getDashboardUserData() {
      this.statusLoding = true;
      var token = sessionStorage.getItem("myToken");

      this.queryParams.startDate = this.getFormatDate(this.fullDate[0]);
      this.queryParams.endDate = this.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append("objs", param);

      this.$http
        .post("/api/select/dashboardUserData?access_token=" + token, data, null)
        .then((result) => {
          this.dashboardUserData = result.data;
        });
    },
    // 기업회원 현황
    getDashboardCompanyData() {
      this.statusLoding = true;
      var token = sessionStorage.getItem("myToken");

      this.queryParams.startDate = this.getFormatDate(this.fullDate[0]);
      this.queryParams.endDate = this.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append("objs", param);

      this.$http
        .post("/api/select/dashboardCompanyData?access_token=" + token, data, null)
        .then((result) => {
          this.dashboardCompanyData = result.data;
        });
    },
    // 주문현황 - 기업회원 가입
    getDashboardOrderCompany() {
      var self = this;
      var token = sessionStorage.getItem("myToken");

      this.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.getFormatDate(this.fullDate[1]);
      this.queryParams.order_type = "AP";

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObjs', param);

      self.$http.post('/api/select/drOrderTotalList?access_token=' + token, data, null)
      .then((result) => {
        // self.items = result.data;
        result.data.forEach(function (el, idx, arr){
          if(el.status == "ORDER_STATUS_TYPE_1"){
            self.dashboardOrderCompany.totalOrderCnt++;
            self.dashboardOrderCompany.totalOrderPrice += parseInt(el.price);
            self.dashboardOrderCompany.depositCnt++;
            self.dashboardOrderCompany.depositPrice += parseInt(el.price);
          }
          if(el.status == "ORDER_STATUS_TYPE_3"){
            self.dashboardOrderCompany.totalOrderCnt++;
            self.dashboardOrderCompany.totalOrderPrice += parseInt(el.price);
            self.dashboardOrderCompany.paymentCnt++;
            self.dashboardOrderCompany.paymentPrice += parseInt(el.price);
          }
        });
      })
    },
    // 주문현황 - 보고서판매
    getDashboardOrderReport() {
      var self = this;
      var token = sessionStorage.getItem("myToken");

      this.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.getFormatDate(this.fullDate[1]);
      this.queryParams.order_type = "RP";

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('orderObjs', param);

      self.$http.post('/api/select/drOrderTotalList?access_token=' + token, data, null)
      .then((result) => {
        // self.items = result.data;
        result.data.forEach(function (el, idx, arr){
          //신용카드, 무통장입금 결제인 경우만
          if(el.pay_type == "PAY_TYPE_1" || el.pay_type == "PAY_TYPE_2"){
            if(el.status == "ORDER_STATUS_TYPE_1"){
              self.dashboardOrderReport.totalOrderCnt++;
              self.dashboardOrderReport.totalOrderPrice += parseInt(el.amount);
              self.dashboardOrderReport.depositCnt++;
              self.dashboardOrderReport.depositPrice += parseInt(el.amount);
            }
            if(el.status == "ORDER_STATUS_TYPE_3"){
              self.dashboardOrderReport.totalOrderCnt++;
              self.dashboardOrderReport.totalOrderPrice += parseInt(el.amount);
              self.dashboardOrderReport.paymentCnt++;
              self.dashboardOrderReport.paymentPrice += parseInt(el.amount);
            }
          }
        });
      })
    },
    getDashboardReportData() {
      var self = this;
      // var menuParams = [];
      // var menuNames = '';

      // this.menuButtons.forEach(function (el, idx, arr){
      //   if(el.state){
      //     menuParams.push(el.item_code);
      //     menuNames += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+el.item_name+"</span>&nbsp;&nbsp;";
      //   }
      // });

      // this.queryParams.menu_code = menuParams;

      // this.queryParams.r_type = this.dr_rtype;

      this.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.getFormatDate(this.fullDate[1]);

      let token = sessionStorage.getItem("myToken");
      let param = encodeURI(JSON.stringify(this.queryParams));

      let data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/drReportList?access_token=' + token, data, null)
        .then((result) => {
          self.dashboardContentsTotal.totalCnt = result.data.length;
          result.data.forEach(function (el, idx, arr){
            if(el.sales_type == "pay"){
              // 유료 현황
              self.dashboardContentsPay.totalCnt++;
              if(el.dr_type_code == "RPT_TYPE_1"){
                self.dashboardContentsPay.adCnt++;
                self.dashboardContentsTotal.adCnt++;
              }else if(el.dr_type_code == "RPT_TYPE_2"){
                self.dashboardContentsPay.marketCnt++;
                self.dashboardContentsTotal.marketCnt++;
              }else if(el.dr_type_code == "RPT_TYPE_3"){
                self.dashboardContentsPay.custCnt++;
                self.dashboardContentsTotal.custCnt++;
              }else if(el.dr_type_code == "RPT_TYPE_4"){
                self.dashboardContentsPay.briefCnt++;
                self.dashboardContentsTotal.briefCnt++;
              }
            }else if(el.sales_type == "free"){
              // 무료 현황
              self.dashboardContentsFree.totalCnt++;
              if(el.dr_type_code == "RPT_TYPE_1"){
                self.dashboardContentsFree.adCnt++;
                self.dashboardContentsTotal.adCnt++;
              }else if(el.dr_type_code == "RPT_TYPE_2"){
                self.dashboardContentsFree.marketCnt++;
                self.dashboardContentsTotal.marketCnt++;
              }else if(el.dr_type_code == "RPT_TYPE_3"){
                self.dashboardContentsFree.custCnt++;
                self.dashboardContentsTotal.custCnt++;
              }else if(el.dr_type_code == "RPT_TYPE_4"){
                self.dashboardContentsFree.briefCnt++;
                self.dashboardContentsTotal.briefCnt++;
              }
            }
          });

          // self.items = result.data;
          // this.searchReportCount = self.items.length.toLocaleString();

          // self.items.forEach(function (el, idx, arr){
          //   el.rnum = self.items.length - (idx);
          //   el.selectchecked = false;
            // var categorydata = el.category_alldatas.split(',')
            // var categorytags = "";
            // categorydata.forEach(function (el, idx, arr){
            //   categorytags += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+el+"</span>&nbsp;&nbsp;"
            // });
            // el.categorytag = categorytags;
          // });

          // self.selectCateItems.forEach(function (el, idx, arr){
          //   if(el.value == self.queryParams.type_code){
          //     self.searchData.typeCodeName = el.text;
          //   }
          // });
          // self.searchData.menuNames = menuNames;
          // self.searchData.startday = self.queryParams.start_date;
          // self.searchData.endday = self.queryParams.end_date;
          // self.searchData.keyword = self.queryParams.keyword;
          // self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';

        })
    },
    getDashboardQAData() {
      var self = this;

      this.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.getFormatDate(this.fullDate[1]);

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/qaList?access_token=' + token, data, null)
        .then((result) => {
          result.data.forEach(function (el, idx, arr){
            self.dashboardQAData.totalCnt++;
            if(el.qastatus == 1){
              self.dashboardQAData.qaWaitCnt++;
            }else if(el.qastatus == 2){
              self.dashboardQAData.qaSuccCnt++;
            }
          });
      });
    },
    getDashboardReportRequest() {
      var self = this;

      this.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.getFormatDate(this.fullDate[1]);

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/reportRequestList?access_token=' + token, data, null)
        .then((result) => {
          result.data.forEach(function (el, idx, arr){
            self.dashboardQAData.totalCnt++;
            if(el.qastatus == 1){
              self.dashboardQAData.reqWaitCnt++;
            }else if(el.qastatus == 2){
              self.dashboardQAData.reqSuccCnt++;
            }
          });
      });
    },
    // 날짜 정의
    dateRange(flag) {
      let endDate = new Date();
      let startDate = new Date();

      if(flag == 'this_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        endDate = new Date();
      }else if(flag == 'prev_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 1, 1);
        endDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      }else if(flag == 'this_year'){
        startDate = new Date(endDate.getFullYear(), 0, 1);
        endDate = new Date();
      }else if(flag == 'this_week'){
        var monday = endDate.getDate() - endDate.getDay() + 1;
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), monday);
        endDate = new Date();
      }else if(flag == 'download_week'){
        var thursday = endDate.getDate() - endDate.getDay() - 7 + 4;
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), thursday);
        endDate = new Date();
      }
      this.fullDate = [startDate, endDate];
      if(flag == 'all'){
        this.fullDate = [];
      }
      //this.handleDateRangeChange();
    },
    // handleDateRangeChange() {
    //   var self = this;
    //   if(self.fullDate.length > 0){
    //     self.queryParams.start_date = moment(self.fullDate[0]).format("YYYY-MM-DD");
    //     self.queryParams.end_date = moment(self.fullDate[1]).format("YYYY-MM-DD");
    //   }else{
    //     self.queryParams.start_date = '';
    //     self.queryParams.end_date = '';
    //   }
    // },
    downloadExcel(){
      var self = this;
      self.isDownload = true;
      var token = sessionStorage.getItem("myToken");

      const { manager_id } = self.$session.get('userInfo');
      self.queryParams.manageId = manager_id;

      this.queryParams.start_date = this.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      var config = {
          responseType: 'blob'
      };

      self.$http.post('/api/download/dashboardExcel?access_token='+token, data, config)
          .then((result) => {
            console.log(result);
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            var fileName = "기간통계데이터_" + moment().format('YYYYMMDD');
            link.setAttribute('download', fileName + '.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.isDownload = false;
          });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue